<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Allgemeine Informationen</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="back">Zurück</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="forward" form="form">Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="praxisname"
          :counter="250"
          label="Praxisname"
          :rules="praxisnameRule"
        ></v-text-field>
        <v-select
          v-model="praxisart"
          :items="praxisarten"
          label="Praxisart auswählen"
          :rules="praxisartRule"
          v-if="!bestellung.sonderbestellung"
        ></v-select>
        <v-checkbox v-model="asvTeamsAktiv" label="ASV-Teams aktiv"></v-checkbox>
        <v-checkbox
          v-model="manuelleDokumenteLiegenVor"
          label="Manuelle oder unterschriebene Bestelldokumente bereits vorhanden"
        ></v-checkbox>
        <v-menu
          v-model="installDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          v-if="!bestellung.lizenz.lizenzaenderung"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="installDate"
              readonly
              label="Startdatum Softwarepflege"
              v-on="on"
              :rules="installDateRule"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker v-model="installDate" @input="installDateMenu = false"></v-date-picker>
        </v-menu>
        <v-textarea
          v-model="bemerkung"
          label="Bemerkung"
          hint="z.B. Hinweis auf Sonderkonditionen uvm."
        ></v-textarea>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      praxisartRule: [v => !!v || "Praxisart muss ausgewählt werden"],
      praxisnameRule: [v => !!v || "Es muss ein Praxisname angegeben werden"],
      praxisname: "",
      praxisart: "",
      asvTeamsAktiv: false,
      bemerkung: "",
      manuelleDokumenteLiegenVor: false,
      installDateMenu: false,
      installDate: "",
      installDateRule: [
        v =>
          !!v ||
          v === "" ||
          "Das Startdatum Softwarepflege darf nicht leer sein"
      ]
    };
  },
  computed: {
    ...mapState({
      process: state => state.current.process,
      bestellung: state => state.current.bestellung,
      praxisarten: state => state.praxisarten
    })
  },
  mounted: function() {
    this.$store.commit("startLoading");
    this.$socket.sendObj({
      eventID:
        "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
      processId: this.$route.params.process,
      taskId: this.$route.params.task
    });
    this.refreshForm();
  },
  watch: {
    bestellung: function() {
      this.refreshForm();
    }
  },
  methods: {
    refreshForm: function() {
      this.praxisname = this.bestellung.praxisName;
      this.praxisart = this.bestellung.praxisart;
      this.asvTeamsAktiv = this.bestellung.asvTeamsAktiv;
      this.bemerkung = this.bestellung.bemerkung;
      this.manuelleDokumenteLiegenVor = this.bestellung.manuelleDokumenteLiegenVor;
      this.installDate = this.bestellung.installDate;
    },
    back: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BackwardRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    forward: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.praxisart.PraxisartSaveRequestEvent",
          praxisart: this.praxisart.toUpperCase(),
          praxisname: this.praxisname,
          asvTeamsAktiv: this.asvTeamsAktiv,
          taskId: this.$route.params.task,
          processId: this.$route.params.process,
          bemerkung: this.bemerkung,
          manuelleDokumenteLiegenVor: this.manuelleDokumenteLiegenVor,
          installDate: this.installDate
        });
      }
    }
  }
};
</script>
